import { EURO } from '../../../shared/constants/currency.constants';

export const getCurrencySymbol = (currency: string) => {
    switch (currency) {
        case EURO:
            return '€';
        default:
            return currency;
    }
};
